<template>
    <div class="animated fadeIn">
        <b-row>
            <b-col lg="12">
                <b-card>
                    <div slot="header">
                        <strong>Tra cứu, tìm kiếm người sử dụng</strong>
                    </div>
                    <b-form @submit.prevent="search">
                        <b-row>
                            <b-col md="6">
                                <b-form-group label="Tên tài khoản:"
                                              label-for="username"
                                              label-cols-md="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <b-form-input type="text" id="username"
                                                  placeholder="Nhập tài khoản ..."
                                                  v-model="searchForm.username">
                                    </b-form-input>
                                </b-form-group>
                            </b-col>
                            <b-col sm="6">
                                <b-form-group label="Phần mềm đồng bộ:"
                                              :label-cols-md="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <sync-data-source v-model="searchForm.syncSourceType" :options="listSyncSourceTypes" allowClear="true"></sync-data-source>
                                </b-form-group>
                            </b-col>
                            <b-col md="6">
                                <b-form-group label="Đơn vị công tác:"
                                              label-for="unitId"
                                              label-cols-md="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <unit-tree v-model="searchForm.unitId"
                                               id="unitId"
                                               allowTraversal
                                               :traversalOption.sync="searchForm.unitTraversalOption"
                                               ref="unitTree"></unit-tree>
                                </b-form-group>
                            </b-col>
                            <b-col sm="6">
                                <b-form-group label="Phần mềm quản lý:"
                                              :label-cols-md="4"
                                              label-for="manageSourceId"
                                              :horizontal="true"
                                              label-align="left">
                                    <sync-data-source :cached="true"
                                                      v-model="searchForm.manageSourceId"
                                                      :options="listSyncSourceTypes"
                                                      :excluded="[2]"
                                                      id="manageSourceId"
                                                      allowClear="true"></sync-data-source>
                                </b-form-group>
                            </b-col>
                            <b-col md="6" v-if="searchForm.manageSourceId">
                                <b-form-group label="Đơn vị quản lý:"
                                              label-cols-md="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <unit-tree :cached="true" v-model="searchForm.manageUnitId" :syncSourceType="searchForm.manageSourceId"></unit-tree>
                                </b-form-group>
                            </b-col>
                            <b-col md="6">
                                <b-form-group label="Trạng thái duyệt:"
                                              label-for="user_status"
                                              label-cols-md="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <select2 placeholder="--- Tất cả ---"
                                             id="user_status"
                                             v-model="searchForm.isApproved"
                                             v-bind:options="listUserStatus"
                                             allowClear></select2>
                                </b-form-group>
                            </b-col>
                            <b-col md="6">
                                <b-form-group label="Lý do từ chối:"
                                              label-for="rejectReason"
                                              label-cols-md="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <b-form-input type="text" id="rejectReason"
                                                  placeholder="Nhập lý do từ chối ..."
                                                  v-model="searchForm.rejectReason">
                                    </b-form-input>
                                </b-form-group>
                            </b-col>
                            <b-col md="6">
                                <b-form-group label="Nhóm tài khoản người dùng:"
                                              label-cols-md="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <select2 placeholder="--- Tất cả ---"
                                             v-model="searchForm.roleId"
                                             v-bind:options="listRoles"
                                             allowClear></select2>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col offset-md="3">
                                <b-form-group label="" :label-cols="4" label-cols-md="2">
                                    <b-button type="submit" variant="primary">Tìm kiếm</b-button>
                                </b-form-group>
                            </b-col>
                        </b-row>
                    </b-form>
                    <br />
                    <b-grid :searchForm="searchForm"
                            :gridOptions="gridOptions"
                            dataUrl="users/list"
                            gridName="Danh sách người dùng"
                            ref="userTable">
                        <template v-slot:actions v-if="authorize(['ManageUser']) && isAdmin">
                            <router-link to="./create" tag="button" class="btn btn-primary" size="md">
                                Thêm mới
                            </router-link>
                            <!--<b-button size="md" @click.stop="deletes" variant="danger" :disabled="isShowBtnDelete">
                                Xóa
                            </b-button>-->
                        </template>
                        <template v-slot:cell(roles)="row">
                            {{ row.item.roles.join(', ') }}
                        </template>
                        <template v-slot:cell(manageSources)="row">
                            <template v-if="row.item.manageSourcesDistinct.length > 1">
                                <ul class="pl-1">
                                    <li v-for="item in row.item.manageSourcesDistinct">
                                        {{ $store.getters.getSyncSourceType(item) }}
                                    </li>
                                </ul>
                            </template>
                            <template v-else>
                                {{ row.item.manageSourcesDistinct.map(x => $store.getters.getSyncSourceType(x)).join(',') }}
                            </template>
                        </template>
                        <template v-slot:cell(manageUnits)="row">
                            <template v-if="row.item.manageSourcesDistinct.length > 1">
                                <ul class="pl-1">
                                    <li v-for="source in row.item.manageSourcesDistinct">
                                        {{ $store.getters.getSyncSourceType(source) }} : {{ row.value.filter(x => x.syncSourceType == source).map(x => x.unitName).join(', ') }}
                                    </li>
                                </ul>
                            </template>
                            <template v-else>
                                {{ row.value.map(x => x.unitName).join(', ') }}
                            </template>
                        </template>
                        <template v-slot:cell(syncSource)="row">
                            {{ $store.getters.getSyncSourceType(row.value) }}
                        </template>
                        <template v-slot:cell(isLocked)="row">
                            <b-form-checkbox v-model="row.item.isLocked" @change="updateStatus(row.item, $event)" v-show="row.item.isApproved == true"></b-form-checkbox>
                        </template>
                        <template v-slot:cell(isApproved)="row">
                            {{ row.item.isApproved == null ? 'Chờ duyệt' : row.item.isApproved == true ? 'Đã duyệt' : 'Từ chối' }}
                        </template>
                        <template v-slot:cell(rejectReason)="row">
                            {{ row.item.isApproved == true || row.item.isApproved == null ? '' : row.item.rejectReason }}
                        </template>
                        <template v-slot:cell(_actions)="row">
                            <b-button-group>
                                <b-button size="sm" :to="{ path: `./${row.item.id}/detail` }" title="xem" variant="info">
                                    Xem
                                </b-button>
                                <template v-if="authorize(['ManageUser'])">
                                    <b-button size="sm" :to="{ path: `./${row.item.id}/edit` }" title="sửa" variant="primary">
                                        Sửa
                                    </b-button>
                                    <b-button size="sm" @click.stop="remove(row.item, row.index, $event.target)" v-if="isAdmin" class="mr-1" variant="danger" title="xóa">
                                        Xoá
                                    </b-button>
                                    <b-button v-if="row.item.isApproved == false && isAdmin"
                                              @click.stop="resendApproved(row.item, row.index, $event.target)"
                                              size="sm" title="gửi duyệt lại" variant="primary">
                                        Gửi duyệt
                                    </b-button>
                                    <!--<b-button size="sm" :to="{ path: `./${row.item.id}/privileges` }" title="phân quyền">
                                        <i class="fa fa-cogs" aria-hidden="true"></i>
                                    </b-button>-->
                                </template>
                            </b-button-group>
                        </template>
                    </b-grid>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>
<script>
    import { mixins } from '@/shared/mixins'
    import { mapState } from 'vuex';

    export default {
        name: 'ListUser',
        mixins: [mixins],
        data() {
            return {
                searchForm: {
                    username: null,
                    unitId: null,
                    unitTraversalOption: this.getUnitTreeTraversalOptionCache(),
                    manageSourceId: null,
                    manageUnitId: this.getUnitTreeIdCache(this.getSyncSourceTypeCache(null, [2, 101, 102])),
                    roleId: null,
                    rejectReason: null,
                    syncSourceType: null
                },
                gridOptions: {
                    fields: [
                        { key: 'username', label: 'Tên tài khoản', sortable: true, sortDirection: 'asc' },
                        //{ key: 'fullName', label: 'Họ tên', sortable: true },
                        { key: 'unitName', label: 'Đơn vị công tác', sortable: true, tdAttr: (key, value, item) => ({ title: item.unitFullName }) },
                        //{ key: 'phoneNumber', label: 'Số điện thoại', sortable: true },
                        { key: 'manageSources', label: 'Phần mềm quản lý', sortable: false },
                        { key: 'manageUnits', label: 'Đơn vị quản lý', sortable: false, tdAttr: (key, value, item) => ({ title: item.manageUnits.map(x => x.unitName).join(', ') }) },
                        { key: 'roles', label: 'Nhóm tài khoản người dùng', sortable: false },
                        { key: 'syncSource', label: 'Phần mềm đồng bộ', sortable: true },
                        { key: 'isApproved', label: 'Trạng thái duyệt', sortable: true },
                        { key: 'rejectReason', label: 'Lý do từ chối' },
                        { key: 'isLocked', label: 'Khóa tài khoản', sortable: true }
                    ],
                    sortBy: 'username',
                },
                listUserStatus: [
                    { id: "0", text: 'Chờ duyệt' },
                    { id: "1", text: 'Từ chối' },
                    { id: "2", text: 'Đã duyệt' },
                ],
                isShowBtnDelete: true,
                listRoles: []
            }
        },
        computed: {
            ...mapState({
                listSyncSourceTypes: (state) => {
                    return state.common.listSyncSourceTypes.filter(x => x.id != 2);
                }
            })
        },
        created() {
            var vm = this;
            this.$services.get('lookup/roles').done((response) => vm.listRoles = response);
        },
        mounted() {
            this.$watch(
                () => {
                    return this.$refs.userTable.selectedRows
                },
                (val) => {
                    this.isShowBtnDelete = val.length == 0;
                }
            )
        },
        methods: {
            search() {
                this.$refs.userTable.refresh();
            },
            remove(item, index, button) {
                var vm = this;
                if (confirm('Bạn có chắc chắn muốn xóa người dùng này?')) {
                    this.$services.delete(`users/${item.id}`).done(() => {
                        vm.$toastr.s('Xóa người dùng thành công');
                        vm.search();
                    });
                }
            },
            deletes() {
                var vm = this;
                var selectedRows = this.$refs.userTable.selectedRows;
                if (selectedRows.length > 0) {
                    if (confirm('Bạn có chắc chắn muốn xóa các người dùng này?')) {
                        var data = selectedRows.map(x => x.id).join(',');
                        this.$services.delete(`users?ids=${data}`).done(() => {
                            vm.$toastr.s('Xóa người dùng thành công');
                            vm.search();
                        });
                    }
                }
                else {
                    vm.$toastr.e('Vui lòng chọn người dùng cần xóa');
                }
            },
            updateStatus(user, checked) {
                var action = checked ? "khóa" : "mở khóa";
                if (confirm('Bạn có chắc muốn ' + action + ' người dùng này?')) {
                    this.$services.put(`users/${user.id}/status`);
                } else {
                    this.$nextTick(() => user.isLocked = !checked);
                }
            },
            resendApproved(item, index, button) {
                if (confirm('Bạn có chắc chắn muốn gửi duyệt người dùng này?')) {
                    this.$services.put(`users/approved/${item.id}/resend`).done(() => {
                        this.$toastr.s('Gửi duyệt thành công');
                        this.search();
                    });
                }
            }
        }
    }
</script>
<style scoped>
</style>
